import { Navigate, useLocation } from "react-router-dom";
import { PageLoader } from "src/components/PageLoader/PageLoader";
import { isAuth0Callback, useAuth, useSignInRecovery } from "src/infrastructure/auth";
import { SignInFailedPage } from "src/pages/SignInFailedPage/SignInFailedPage.page";

/**
 * Where Auth0 sends the browser after sign-in (`AUTH0_CALLBACK_URL` may end in
 * `/callback`, as in twosion-ui). The auth provider finishes the code exchange
 * and then navigates to the page sign-in started from; this page covers the
 * wait and an Auth0 error.
 *
 * While the URL is an Auth0 callback (Auth0's own rule, `isAuth0Callback`) it
 * keeps showing the loader, even once Auth0 reports it has finished: the
 * router applies that navigation in a transition, so this page can render once
 * more before it leaves, and sending the user home then would override the
 * page they started from. Anything Auth0 won't process (no callback
 * parameters, a lone `state`, auth disabled) goes home instead of waiting
 * forever.
 * Reference: twosion-ui src/pages/Auth0Callback/Auth0Callback.page.tsx.
 */
export function SignInCallbackPage() {
  const { isEnabled, isLoading, error } = useAuth();
  const { tryAgain, signOut } = useSignInRecovery();
  const { search } = useLocation();

  if (error) {
    return <SignInFailedPage message={error.message} onTryAgain={tryAgain} onSignOut={signOut} />;
  }
  if (isEnabled && (isLoading || isAuth0Callback(search))) return <PageLoader label="Signing in" />;
  return <Navigate to="/" replace />;
}
